<div soho-busyindicator style="flex-direction: column"
     [text]="'BuildingWebApplicationNavigationTree' | translate"
     [displayDelay]="20"
     [timeToComplete]="busyTimeOut">
    <div class="form-layout-compact">
        <ng-container *ngIf="true then HEADER"></ng-container>
        <div class="lm-flex-row-responsive-container">
            <div class="one-third column">
                <ng-container *ngIf="true then WEB_APP_COMPONENTS"></ng-container>
            </div>
            <div class="two-thirds column">
                <ng-container *ngIf="true then WEB_APP_ITEMS"></ng-container>
            </div>
        </div>
        <ng-container *ngIf="true then INACCESSIBLE_ITEMS"></ng-container>
    </div>
</div>

<!-- HEADER -->
<ng-template #HEADER>
    <div class="lm-flex-row-container-no-wrap">
        <div class="field">
            <label soho-label for="lm-menu-security-webapp">{{'WebApplication' | translate}}</label>
            <p id="lm-menu-security-webapp" data-automation-id="lm-menu-security-webapp" class="lm-display-as-text">{{options.webApp}}</p>
        </div>
        <div class="field">
            <label soho-label for="lm-menu-security-role">{{'Role' | translate}}</label>
            <p id="lm-menu-security-role" data-automation-id="lm-menu-security-role" class="lm-display-as-text">{{options.role}}</p>
        </div>
    </div>
</ng-template>
<!-- COMPONENTS -->
<ng-template #WEB_APP_COMPONENTS>
    <div class="row">
        <div class="lm-flex-field-set-header">
            <div data-automation-id="lm-menu-security-components-title" class="fieldset-title">{{'Components' | translate}}
                <lm-mouse-over-text data-automation-id="lm-menu-security-components-info" [mouseOverTextContents]="'WebAppComponentHelp' | translate"></lm-mouse-over-text></div>
        </div>
        <soho-listview #SohoListView_Items data-automation-id="lm-menu-security-components-listview"
           selectable='true'
           disableItemDeactivation="'true'"
           (selected)="onWebAppComponentSelected($event)">
            <li soho-listview-item *ngFor="let component of webAppComponents; index as i">
                <ng-container [ngTemplateOutlet]="COMPONENT_CARD" [ngTemplateOutletContext]="{ component:component, i:i}"></ng-container>
            </li>
        </soho-listview>
    </div>
</ng-template>
<!-- COMPONENT CARD -->
<ng-template #COMPONENT_CARD let-component="component" let-i="i">
    <div attr.data-automation-id="lm-menu-security-component-name-{{i}}" class="font-size-sm lm-bold">{{component.name}}</div>
    <div attr.data-automation-id="lm-menu-security-component-type-{{i}}" class="font-size-xs">{{component.type | translate}}</div>
    <div class="lm-flex-row-container-no-wrap-right ">
        <a soho-hyperlink (click)="onComponentInfoClick(component)" icon="info" attr.data-automation-id="lm-menu-security-component-info-anchor-{{i}}">{{'Detail' | translate}}</a>
    </div>
</ng-template>
<!-- ITEMS -->
<ng-template #WEB_APP_ITEMS>
    <div class="row">
        <div class="lm-flex-field-set-header">
            <div data-automation-id="lm-menu-security-items-title" class="fieldset-title">{{'Items' | translate }}
            <lm-mouse-over-text data-automation-id="lm-menu-security-items-info" [mouseOverTextContents]="'WebAppItemComponentHelp' | translate"></lm-mouse-over-text></div>
        </div>
        <div *ngIf="gridOptions" soho-datagrid #SohoDataGrid data-automation-id="lm-menu-security-items-data-grid"
             [gridOptions]="gridOptions"
             (rowActivated)="onRowActivated($event)"
             (cellchange)="onPropertiesChange($event)">
        </div>
    </div>
</ng-template>
<!-- INACCESSIBLE ITEMS -->
<ng-template #INACCESSIBLE_ITEMS>
    <div class="lm-flex-column-responsive-container">
        <div class="lm-flex-field-set-header">
            <div data-automation-id="lm-menu-security-inaccessible-items-title" class="fieldset-title">{{'InaccessibleItems' | translate }}
            <lm-mouse-over-text data-automation-id="lm-menu-security-inaccessible-items-info" [mouseOverTextContents]="'InaccessibleItemsHelp' | translate"></lm-mouse-over-text></div>
        </div>
        <soho-listview #SohoListView_InaccessibleItems data-automation-id="lm-menu-security-inaccessible-items-listview"
           selectable='true'
           disableItemDeactivation="'true'">
            <li soho-listview-item *ngFor="let item of notAccessibleItemsKeys; index as i">
                <div class="lm-flex-row-container-no-wrap">
                    <span attr.data-automation-id="inaccessible-item-{{item}}" class="font-size-sm lm-bold">{{item}}</span>
                    <span *ngIf="!notAccessibleItems[item]">
                        <svg attr.data-automation-id="lm-menu-security-inaccessible-item-alert-{{item}}"class="icon icon-alert lm-alert"
                         soho-tooltip [content]="'InvalidInaccessibleItemAlert' | translate"><use xlink:href="#icon-alert"></use></svg>
                    </span>
                    <span class="lm-flex-row-container-no-wrap-right ">
                        <button soho-button="tertiary" icon="delete" (click)="onInaccessibleItemRemove(item)" attr.data-automation-id="lm-menu-security-inaccessible-item-delete-btn-{{item}}">{{'Delete' | translate}}</button>
                    </span>
                </div>
            </li>
        </soho-listview>
    </div>
</ng-template>




